import { cloneDeep } from 'lodash';
import isEmail from 'validator/es/lib/isEmail';

import type { ContactStateType, ContactErrors } from '../types';

function isFirstNameValid(firstName: string): boolean {
  return !!firstName;
}

function isEmailValid(email: string): boolean {
  if (!email || isEmail(email)) {
    return true;
  }

  return false;
}

function isEmailRequired(email: string, sendEmail: boolean): boolean {
  return sendEmail && !email;
}

function isPhoneRequired({
  mustCall,
  number,
  sendSms,
}: ContactStateType['phone'][0]): boolean {
  return (mustCall || sendSms) && !number;
}

const DEFAULT_CONTACT_ERRORS: ContactErrors = {
  firstName: '',
  email: '',
  phone: [],
  rep: '',
};

export function runValidation(
  contact: ContactStateType,
): [ContactErrors, boolean] {
  const errors = cloneDeep(DEFAULT_CONTACT_ERRORS);
  let isFormValid = true;
  switch (contact.type) {
    case 'Agent': {
      if (!contact.rep) {
        errors.rep = 'Please select an agent.';
        isFormValid = false;
      }
      break;
    }
    case 'Concierge':
    case 'Seller':
    case 'Tenant':
    case 'Landlord/Manager':
    case 'Buyer': {
      const { firstName, email, deliveries, phone } = contact;

      if (!isFirstNameValid(firstName)) {
        errors.firstName =
          contact.type === 'Concierge'
            ? 'Contact / Building name is required.'
            : 'First name is required.';
        isFormValid = false;
      }
      if (!isEmailValid(email)) {
        errors.email = 'Email is invalid.';
        isFormValid = false;
      } else if (isEmailRequired(email, deliveries.Email)) {
        errors.email = 'Email is required.';
        isFormValid = false;
      }

      phone.forEach(phoneEntry => {
        let phoneError = '';
        if (isPhoneRequired(phoneEntry)) {
          phoneError = 'Phone number is required.';
          isFormValid = false;
        }
        errors.phone.push(phoneError);
      });

      break;
    }
    default: {
      throw new Error('Invalid contact type');
    }
  }

  return [errors, isFormValid];
}
